import { initPlasmicLoader } from '@plasmicapp/loader-nextjs';

export const PLASMIC = initPlasmicLoader({
  projects: [
    {
      id: process.env.PLASMIC_PROJECT_ID,
      token: process.env.PLASMIC_API_TOKEN
    }
  ],
  preview: true
});

import { CODE_COMPONENTS } from 'react-scale/components/plasmic';

CODE_COMPONENTS.forEach(({ component, ...options }) => {
  PLASMIC.registerComponent(component, { props: {}, ...options });
});
